module.exports = __webpack_public_path__ + "static/DigitalRiver-0e535c44a26b3eacb82555b20163cfeb.svg";